import Api from '@/plugins/Api'

import { IMailPayload } from './types'

class MailService {
  async sendRequest(payload: IMailPayload) {
    try {
      const res = await Api.post('/mail', payload)

      return res
    } catch (e) {
      throw e
    }
  }
}

export default new MailService()
